import { render } from "./marker.vue?vue&type=template&id=60380380"
import script from "./marker.vue?vue&type=script&lang=js"
export * from "./marker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__